module.exports = __webpack_public_path__ + "img/31.b6ae54f8.png";